import { Component, ChangeDetectionStrategy, input, output } from '@angular/core'
import { CheckboxListComponent } from './checkbox-list.component'
import { BvViewFilterOption, FilterOptionsMap } from './models'

@Component({
  selector: 'view-filter-options',
  template: `
    @if (selectedFilter(); as selectedFilter) {
      <checkbox-list
        [loading]="loading()"
        [options]="filterOptions()"
        [selected]="selectedFilter"
        (onFilterChange)="
          onFilterChange.emit({
            filter: selectedFilter,
            option: $event.option
          })
        "
      ></checkbox-list>
    } @else {
      <div>
        @for (section of filters(); track section) {
          <div class="border-b border-gray-200 p-2">
            @for (filter of section; track filter) {
              <div
                class="hover:bg-gray-200 px-3 py-2 text-sm cursor-pointer"
                (click)="onSelectFilter.emit({ event: $event, filterName: filter })"
              >
                {{ filter }}
              </div>
            }
          </div>
        }
      </div>
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CheckboxListComponent],
})
export class ViewFilterOptionsComponent<T> {
  readonly filters = input<T[][]>()
  readonly selectedFilter = input<string | undefined | null>()
  readonly filterOptions = input<FilterOptionsMap | undefined>()
  readonly loading = input(false)
  readonly onFilterChange = output<{ filter: string; option: BvViewFilterOption }>()
  readonly onSelectFilter = output<{ event: MouseEvent; filterName: T | undefined }>()
}
